import { getAuthItem } from '@/lib/authStorage';
import { getActiveWorkspaceId } from '@/lib/api/workspace-context';

/**
 * Auth headers including the active workspace id (used by the panel, whose
 * /contacts calls require X-Workspace-Id).
 */
export function getAuthHeaders(): HeadersInit {
  const token = getAuthItem('xavior_auth_token');
  const userId = getAuthItem('userId');
  const workspaceId = getActiveWorkspaceId();
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(userId ? { 'X-User-Id': userId } : {}),
    'X-Workspace-Id': workspaceId,
  };
}

/**
 * Auth headers without the workspace id (used by the config modal, whose
 * plugin endpoints derive the workspace from the URL path).
 */
export function getAuthHeadersNoWorkspace(): HeadersInit {
  const token = getAuthItem('xavior_auth_token');
  const userId = getAuthItem('userId');
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(userId ? { 'X-User-Id': userId } : {}),
  };
}
